/* eslint @typescript-eslint/explicit-function-return-type: "off" */
import { pages } from 'constants/pages'
import { useNavigate } from 'react-router-dom'

export function useAuthNavigation() {
  function navigateToLogout() {
    window.location.replace(pages.logout)
  }

  function navigateToSignup() {
    window.location.replace(pages.signup)
  }

  return {
    navigateToLogout,
    navigateToSignup,
  }
}

export function usePageNavigation() {
  const navigate = useNavigate()

  function navigateToDashboard() {
    navigate(pages.dashboard)
  }

  function navigateToCampaigns() {
    navigate(pages.campaigns)
  }

  function navigateToNewCampaign() {
    navigate(pages.newCampaign)
  }

  function navigateToConnect() {
    navigate(pages.connect)
  }
  function navigateToSubscriptions() {
    navigate(pages.subscription)
  }
  function navigateToPostScheduling() {
    navigate(pages.post)
  }
  function navigateToUserPosts() {
    navigate(pages.userPosts)
  }
  function navigateToProfile() {
    navigate(pages.profile)
  }
  function navigateToTrends() {
    navigate(pages.trends)
  }
  function navigateToTargetCreators() {
    navigate(pages.target.creators)
  }
  function navigateToTargetAudience() {
    navigate(pages.target.intro)
  }
  function navigateToTargetFollowers() {
    navigate(pages.target.followers)
  }
  function navigateToAutomations(platform?: string) {
    if (platform === 'Youtube') {
      navigate(pages.automationsYoutube)
    } else {
      navigate(pages.automations) 
    }
  }
  
  function navigateToCreateAutomation(platform?: string) {
    if (platform) {
      navigate(`${pages.createAutomation}?platform=${platform}`)
    } else {
      navigate(pages.createAutomation)
    }
  }
  function navigateToFollowerAnalytics() {
    navigate(pages.followerAnalytics)
  }
  function navigateToPopularity() {
    navigate(pages.popularity)
  }
  function navigateToSocialCards() {
    navigate(pages.socialcards)
  }
  function navigateToSocialComments() {
    navigate(pages.socialcomments)
  }
  function navigateToPostDetails() {
    navigate(pages.postdetails)
  }
  function navigateToFollowersList() {
    navigate(pages.followerslist)
  }
  function navigateToAllAnalytics() {
    navigate(pages.allAnalytics)
  }
  function navigateToConnectedAccounts() {
    navigate(pages.connectedAccounts)
  }
  function navigateToDiscoverContent() {
    navigate(pages.discoverContent)
  }
  function navigateToSuperFans() {
    navigate(pages.superFans)
  }
  function navigateToListeningTopics() {
    navigate(pages.listeningTopics)
  }
  function navigateToAnalytics() {
    navigate(pages.analytics)
  }
  function navigateToAccounts() {
    navigate(pages.accounts)
  }
  function navigateToPosts() {
    navigate(pages.posts)
  }
  function navigateToAdmin() {
    navigate(pages.admin)
  }
  return {
    navigateToDashboard,
    navigateToCampaigns,
    navigateToListeningTopics,
    navigateToAnalytics,
    navigateToAccounts,
    navigateToPosts,
    navigateToNewCampaign,
    navigateToConnect,
    navigateToSubscriptions,
    navigateToPostScheduling,
    navigateToUserPosts,
    navigateToProfile,
    navigateToTrends,
    navigateToTargetCreators,
    navigateToTargetAudience,
    navigateToTargetFollowers,
    navigateToAutomations,
    navigateToCreateAutomation,
    navigateToPopularity,
    navigateToSocialCards,
    navigateToSocialComments,
    navigateToPostDetails,
    navigateToFollowersList,
    navigateToAllAnalytics,
    navigateToConnectedAccounts,
    navigateToFollowerAnalytics,
    navigateToDiscoverContent,
    navigateToSuperFans,
    navigateToAdmin,
  }
}
